module.exports = __webpack_public_path__ + "static/media/kefa-ii-pro-regular.4256d9de.woff";